import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_268: DocMigration = {
  maxSchemaVersion: "0.0.268",
  description: "Mark existing electrical room wall positions as using a deprecated placement method",
  apply(json: any) {
    const electricalSystem = json.electricalSystem;
    const loads = electricalSystem?.loads;
    const controllers = electricalSystem?.controllers;
    if (loads) {
      for (const loadId in loads) {
        const load = loads[loadId];
        const position = load?.position;
        if (position) {
          if (position.type === "WALL") {
            position.placementStyle = "DEPRECATED";
          }
        }
      }
    }

    if (controllers) {
      for (const controllerId in controllers) {
        const controller = controllers[controllerId];
        for (const selection of controller.selections) {
          if (selection.type === "EXPLICIT POSITION") {
            const position = selection.explicitQueryPoint.position;
            position.placementStyle = "DEPRECATED";
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_268;
